if (!customElements.get('pastael-gifting-gift-card')) {
  class PastaelGiftingGiftCard extends HTMLElement {
    connectedCallback() {
      this.productForm = this.querySelector('product-form');
      this.form = this.querySelector('[data-gift-card-form]');
      this.variantInput = this.form?.querySelector('[data-variant-input]');
      this.selectedLabel = this.querySelector('[data-selected-amount]');
      this.submitButton = this.form?.querySelector('[type="submit"]');

      this.addEventListener('click', this.onClick.bind(this));
    }

    onClick(event) {
      const option = event.target.closest('[data-amount-option]');
      if (!option || !this.contains(option)) return;
      event.preventDefault();
      this.selectVariant(option);
    }

    selectVariant(option) {
      if (option.disabled || option.getAttribute('aria-disabled') === 'true') return;

      const variantId = option.dataset.variantId;
      const label = option.dataset.variantLabel || option.textContent.trim();
      if (!variantId) return;

      this.querySelectorAll('[data-amount-option]').forEach((button) => {
        const active = button === option;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });

      if (this.variantInput) {
        this.variantInput.value = variantId;
        this.variantInput.disabled = false;
      }

      if (this.selectedLabel) {
        this.selectedLabel.textContent = label;
      }

      if (this.submitButton) {
        this.submitButton.disabled = false;
        this.submitButton.removeAttribute('aria-disabled');
      }
    }
  }

  customElements.define('pastael-gifting-gift-card', PastaelGiftingGiftCard);
}
